@if (subcategories?.length > 0) {
  <sd-subcategories sd-component-wrapper-component
    [subcategories]="subcategories"
    [hasNoPushData]="!pushCardData"
    [pushTemplate]="push"
    [parentsThemesConfig]="themeConfig"
    [linkCardSubcategories]="linkCardSubcategories"
    (subCatClicked)="onSubCateClicked($event)"
  />
}

<ng-template #pushTemplate>
  @if (!!pushCardData) {
    <sd-push-card
      id="pushComponent"
      (click)="onPromoClick()"
      [pushSize]="pushSizeEnum.s"
      [textConfig]="pushCardTextConfig"
      [mediaConfig]="pushCardMediaConfig"
      [push]="pushCardData"
      [imageRatio]="pushCardImageRatio"
      [titleLevel]="3"
      [themesConfig]="pushCardThemeConfig"
      [mediaAsBackground]="pushCardMediaAsBackground"
    />
  }
</ng-template>
